import React from 'react'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'


function About() {
  return (
    <div>
      <section className='bggrey1'>
      <Container>
        <Row>
          <Col>
          <p className='text-start py-3'>
          <strong>Jaya Jaya Sri Sudarsana!</strong>

<p>Sri Venugopala Swamy temple is around 120 years old and is probably the oldest temple in Bolaram. The presiding deity here is Sri Rukmini Satyabhama Godhadevi sametha Sri Venugopala Swamy. Also, the presiding deity is Chaturbhuja Venugopala Swamy (Lord Krishna with 4 hands, flute and a cow) which is very unique and exclusive to the Sri Vaishnava Pancharatra tradition. The daily, fortnightly, monthly and annual rituals are being performed in maximum accordance to the Shastras and with the active participation of devotees for several decades now.</p>

<p>
Some <strong>notable utsavams</strong> ąre:
<br/>
<br/>
1.	<strong>Janmasthami Utsavam</strong> - This is a 4-day utsavam that includes Dolotsavam, Sudarshana Homam, Lakshaarchana, Thirumanjanam etc.
<br/>
<br/>
2.	<strong>Dhanur Masa Utsavam</strong> - Thiruppaavai is celebrated the whole month with recitals, alankaram, bhajans, archana, lectures, rangoli, dance etc. where devotees visit the temple each day in large numbers and sumptuous prasadam is served to all of them.
<br/>
<br/>
3.	<strong>Vaikunta Ekadasi Rathayatra</strong>- This is a very rare utsavam where Lord Sri Venugopala swamy along with his consorts Sri Rukmini and Satyabhama, travels on both - Chariot (Ratha) and Garuda Vahana - in and around the streets of Bolaram.
<br/>
<br/>
4.	<strong>Godha Kalyanotsavam</strong> - This is performed on Pongal/Bhogi where a humongous crowd of devotees visit the temple and annadaanam is performed on a large scale.
<br/>
<br/>

Other miscellaneous utsavams like the Ekadasi, Rohini, Akshaya Tritiya, Dhana Trayodashi, Kartika Pournami, Andal Thiruvaadipooram are quite well-known here.
</p>

<p>
Many Acharyas/Saints like HH Srimad Thirukkudanthai Andavan, HH Srimad Mushnam Andavan (I and II) of Srirangam Srimad Andavan Ashramam, HH Srimad Azhagiyasingar - the 46th Jeer of Sri Ahobila Math, HH Sri Parakala Swami - the 36th Jeer of Sri Brahmatantra Svatantra Parakala Swamy Math, HH Sri Paravakottai Andavan of Srimad Andavan Poundarikapuram Swamy Ashramam, HH Sri Ramachandra Jeer of Bhimavaram have visited and performed their Mangalashasanams in our temple.
</p>
          </p>
          </Col>
        </Row>
      </Container>
      </section>
    </div>
  )
}

export default About